import { tv } from "../../../variants/tv.js";
const tdVariants = tv({
    base: 'text-body2 bg-inherit px-3 relative',
    slots: {
        content: ''
    },
    variants: {
        size: {
            sm: {
                base: 'py-2'
            },
            md: {
                base: 'py-3'
            },
            lg: {
                base: 'py-4'
            }
        },
        align: {
            left: {
                base: 'text-left'
            },
            center: {
                base: 'text-center'
            },
            right: {
                base: 'text-right'
            }
        },
        firstColumnSticky: {
            true: {
                base: 'first:z-1 first:border-l-1 border-r-1 border-primary-5 first:sticky first:left-0'
            }
        },
        rowStriped: {
            false: {
                base: 'border-b-1 border-primary-5'
            }
        },
        tableBordered: {
            true: '',
            false: ''
        },
        textWrap: {
            wrap: {
                content: 'text-wrap'
            },
            nowrap: {
                content: 'text-nowrap'
            },
            balance: {
                content: 'text-balance'
            },
            pretty: {
                content: 'text-pretty'
            }
        },
        lineClamp: {
            none: {
                content: 'line-clamp-none'
            },
            1: {
                content: 'line-clamp-1'
            },
            2: {
                content: 'line-clamp-2'
            },
            3: {
                content: 'line-clamp-3'
            },
            4: {
                content: 'line-clamp-4'
            },
            5: {
                content: 'line-clamp-5'
            },
            6: {
                content: 'line-clamp-6'
            }
        },
        maxWidth: {
            auto: {
                content: 'max-w-auto'
            },
            none: {
                content: 'max-w-none'
            },
            '3xs': {
                content: 'max-w-3xs'
            },
            '2xs': {
                content: 'max-w-2xs'
            },
            xs: {
                content: 'max-w-xs'
            },
            sm: {
                content: 'max-w-sm'
            },
            md: {
                content: 'max-w-md'
            },
            lg: {
                content: 'max-w-lg'
            },
            xl: {
                content: 'max-w-xl'
            }
        },
        wordBreak: {
            breakNormal: {
                content: 'break-normal'
            },
            breakWord: {
                content: 'break-word'
            },
            breakAll: {
                content: 'break-all'
            },
            breakKeep: {
                content: 'break-keep'
            }
        },
        isDrawer: {
            true: '',
            false: ''
        },
        isOpen: {
            true: '',
            false: ''
        },
        isGroupHeader: {
            true: 'bg-neutral-2 active:bg-primary-3 font-bold'
        }
    },
    compoundVariants: [
        {
            firstColumnSticky: true,
            tableBordered: true,
            class: {
                base: 'first:border-l-0 last:border-r-0'
            }
        },
        {
            isDrawer: true,
            isOpen: true,
            rowStriped: false,
            class: {
                base: 'first:border-b-0'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        align: 'left',
        firstColumnSticky: false,
        rowStriped: false,
        tableBordered: false,
        textWrap: 'wrap',
        lineClamp: 'none',
        maxWidth: 'auto',
        wordBreak: 'breakNormal'
    }
});
export { tdVariants };
